import { render, staticRenderFns } from "./CreateDoctorPlan.vue?vue&type=template&id=d0cc751a&scoped=true"
import script from "./CreateDoctorPlan.vue?vue&type=script&lang=js"
export * from "./CreateDoctorPlan.vue?vue&type=script&lang=js"
import style0 from "./CreateDoctorPlan.vue?vue&type=style&index=0&id=d0cc751a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cc751a",
  null
  
)

export default component.exports